import React from 'react';
import { Box } from '@mui/material';
import LanguageSwitcher from '../common/LanguageSwitcher';
import ContactSupportIconButton from '../common/ContactSupport';
import { BRAND } from '../../theme/brandTokens';

/** Rendered over primary brand surfaces (auth backdrop, page header band). */
const AuthHeaderActions = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    <ContactSupportIconButton variant="plain" sx={{ color: BRAND.onPrimary }} />
    <LanguageSwitcher sx={{ mb: 0 }} />
  </Box>
);

export default AuthHeaderActions;
